<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.medicalFiles', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
<!--                <div class="card-title">-->
<!--                    <router-link :to="{ name: 'add-medical-file' }" v-if="can">-->
<!--                        {{ $t('message.add') }}-->

<!--                        <i class="fas fa-plus-circle edit-icon"></i>-->
<!--                    </router-link>-->
<!--                </div>-->

                <template v-if="rows">

                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mMedicalFiles"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="medical-files-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mMedicalFiles"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-medical-file', params: { file: data.item.slug } }" disabled>
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.medicalFiles', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.number }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteMedicalFile(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="medical-files-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "MedicalFiles",

        computed: {
            ...mapGetters(["files",'hasAdminRole',
                'hasGestionnaireRole','hasAssistante','hasSouscripteurRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante || this.hasSouscripteurRole;
            },
            mMedicalFiles: function() {
                let fArray = [];

                _.forEach((_.orderBy(this.files,['created_at'],['desc'])), function(file) {
                    let f = {};

                    f.number = file.numero_dossier;
                    f.date = moment(file.created_at).format('DD-MM-YYYY HH:mm');
                    f.id = file.id;
                    f.slug = file.slug;
                    if (typeof file.patient == 'object' ){
                        let prenom = ( (file.patient.user.prenom == null) ? '' : file.patient.user.prenom);
                        prenom =  prenom.toLowerCase();
                        f.name =  (file.patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    }

                    fArray.push(f);
                });

                return fArray;
            },

            rows: function() {
                return this.mMedicalFiles.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                fields: [
                    {
                        key: 'name',
                        label: this.$i18n.t('message.name'),
                        sortable: true
                    },
                    {
                        key: 'number',
                        label: this.$i18n.t('message.fileNumber'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getMedicalFiles() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getMedicalFiles', { args : args });
            },

            formattedDisplay (result) {
                return result.name;
            },

            itemSelected(item) {
                this.$router.push({ name: 'medical-file', params: { file: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'medical-file', params: { file: items[0].slug } });
            },

            deleteMedicalFile(file) {
                let self = this;

                let args = {
                    file: file
                };

                let successMessage = this.$i18n.t('message.medicalFileDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteMedicalFile', { args, index: file, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + file);
                    });
            }
        },

        mounted() {
            // Fetch medical file list
            this.getMedicalFiles();
        }
    }
</script>

<style scoped>

</style>